import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Layout as AntLayout, Menu, Button, Typography, Avatar } from 'antd';
import {
  DashboardOutlined,
  WalletOutlined,
  UserOutlined,
  TransactionOutlined,
  LogoutOutlined,
  ShopOutlined,
  CoffeeOutlined,
  FileExcelOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import { colors, shadows } from '../theme';

const { Header, Content } = AntLayout;
const { Text } = Typography;

export interface AdminMenuItem {
  key: string;
  icon: React.ReactNode;
  label: string;
}

interface AdminLayoutProps {
  children: React.ReactNode;
  userEmail?: string;
  onSignOut: () => void;
  logoSrc?: string;
  menuItems?: AdminMenuItem[];
  basePath?: string;
}

const defaultMenuItems: AdminMenuItem[] = [
  {
    key: '',
    icon: <DashboardOutlined />,
    label: 'Painel',
  },
  {
    key: '/wallets',
    icon: <WalletOutlined />,
    label: 'Carteiras',
  },
  {
    key: '/booth-wallets',
    icon: <ShopOutlined />,
    label: 'Carteiras Estandes',
  },
  {
    key: '/users',
    icon: <UserOutlined />,
    label: 'Usuários',
  },
  {
    key: '/transactions',
    icon: <TransactionOutlined />,
    label: 'Transações',
  },
  {
    key: '/booths',
    icon: <ShopOutlined />,
    label: 'Estandes',
  },
  {
    key: '/menu',
    icon: <CoffeeOutlined />,
    label: 'Cardápio',
  },
  {
    key: '/reports',
    icon: <FileExcelOutlined />,
    label: 'Relatórios',
  },
  {
    key: '/danger-zone',
    icon: <WarningOutlined />,
    label: 'Danger Zone',
  },
];

export function AdminLayout({
  children,
  userEmail,
  onSignOut,
  logoSrc = '/logo.png',
  menuItems = defaultMenuItems,
  basePath = '/admin'
}: AdminLayoutProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const fullMenuItems = menuItems.map(item => ({
    ...item,
    key: `${basePath}${item.key}`,
  }));

  return (
    <AntLayout style={{ minHeight: '100vh', background: colors.background }}>
      <Header
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0 32px',
          background: colors.primaryDark,
          boxShadow: shadows.md,
          position: 'sticky',
          top: 0,
          zIndex: 100,
          height: 64,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img
            src={logoSrc}
            alt="FestPix"
            style={{
              height: 70,
              width: 'auto',
              objectFit: 'contain',
            }}
          />
        </div>

        <Menu
          mode="horizontal"
          selectedKeys={[location.pathname]}
          items={fullMenuItems}
          onClick={({ key }) => navigate(key)}
          style={{
            background: 'transparent',
            borderBottom: 'none',
            flex: 1,
            justifyContent: 'center',
          }}
          theme="dark"
        />

        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <Avatar
              size={32}
              style={{
                background: 'rgba(255, 255, 255, 0.2)',
                color: '#fff',
              }}
              icon={<UserOutlined />}
            />
            <Text style={{ color: 'rgba(255, 255, 255, 0.85)', fontSize: 13 }}>
              {userEmail?.split('@')[0]}
            </Text>
          </div>
          <Button
            type="text"
            icon={<LogoutOutlined />}
            onClick={onSignOut}
            style={{
              color: 'rgba(255, 255, 255, 0.85)',
              borderRadius: 8,
            }}
          >
            Sair
          </Button>
        </div>
      </Header>
      <Content
        style={{
          padding: '32px',
          maxWidth: 1440,
          margin: '0 auto',
          width: '100%',
        }}
      >
        {children}
      </Content>
    </AntLayout>
  );
}

export default AdminLayout;
